import { ContestTaskRenderer } from '../utils/ContestTaskRenderer.js';

export default class ContestTaskLeaderboardMap {

    constructor() {
        this.contest_task_id = 0;
        this.track_ids = [];
        this.contest_task_geojson = null;
        this.map = null;
        this.paths = [];
        this.renderer = null;
        this.originalMapHeight = null;
        this.taskRendered = false;
        this.tracksRendered = false;

        this.bindEvents();
        this.initMap();
    }

    bindEvents(){
    }

    onDataChanged(data) {
        this.contest_task_id = data.contest_task_id;
        this.track_ids = data.track_ids;
        this.contest_task_geojson = data.contest_task_geojson;

        this.drawContestTask();
        this.loadTrackPoints();
    }


    onDestroy(){
        this.map.remove();
    }

    initMap() {
        let height = $("#leaderboard-map").parent().height();
        if(height<400){
            height = 400;
        }
        $("#leaderboard-map").height(height);

        // Store the original height for restoring after fullscreen
        this.originalMapHeight = height;

        this.map = L.map('leaderboard-map').setView([41.831131, 15.624207], 2);

        L.tileLayer('https://tile.tracestrack.com/_/{z}/{x}/{y}.png?key=5b37c4cf109fa26755308c3a5e221369'
        ).addTo(this.map);

        // Initialize the renderer
        this.renderer = new ContestTaskRenderer(this.map);

        // Add fullscreen button
        this.addFullscreenButton();
    }

    addFullscreenButton() {
        const full_screen_btn = L.easyButton(
            '<span class="fs-18 mt-1 text-gray ff-lato" id="full-toggle" data-toggle="tooltip" data-placement="bottom" title="' +
                I18n.t("website.home.index.full_screen") +
                '"><i id="full-icon" class="fas fa-expand"></i></span>',
            () => {
                if (
                    document.fullscreenElement ||
                    document.webkitFullscreenElement ||
                    document.mozFullScreenElement ||
                    document.msFullscreenElement
                ) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    let element = $("#leaderboard-container").get(0);
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.webkitRequestFullscreen) {
                        element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                    } else if (element.msRequestFullscreen) {
                        element.msRequestFullscreen();
                    }
                }
            }
        );

        full_screen_btn.addTo(this.map);

        // Listen for fullscreen changes to resize the map
        const onFullscreenChange = () => {
            setTimeout(() => {
                if (
                    document.fullscreenElement ||
                    document.webkitFullscreenElement ||
                    document.mozFullScreenElement ||
                    document.msFullscreenElement
                ) {
                    // Entering fullscreen - set map to 100vh
                    $("#leaderboard-map").height('100vh');
                } else {
                    // Exiting fullscreen - restore original height
                    $("#leaderboard-map").height(this.originalMapHeight);
                }
                this.map.invalidateSize();

                // Re-fit bounds to use all available space
                this.fitBoundsIfReady();
            }, 100);
        };

        document.addEventListener('fullscreenchange', onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', onFullscreenChange);
        document.addEventListener('mozfullscreenchange', onFullscreenChange);
        document.addEventListener('MSFullscreenChange', onFullscreenChange);
    }

    drawContestTask() {
        // Use the renderer to load and display the contest task
        // Don't fit bounds yet - wait for tracks to load
        this.renderer.renderFromAPI(this.contest_task_id, () => {
            // Callback is executed after task is rendered
            this.taskRendered = true;
            this.fitBoundsIfReady();
        });
    }

    loadTrackPoints() {
        let self = this;

        let ajaxData = {
            url: window.application.getAPIUrl() + "/v1/contest_task/" + this.contest_task_id + "/leaderboard_tracks_points",
            data: {},
            method: "get",
            beforeSend: function(request) {
                request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
            },
        };
        $.ajax(ajaxData).done(function(data) {
            if (data !== undefined){
                self.drawPath(data);
            }
        }).fail(function() {
        });

    }

    centerView(latlong, zoom = null, duration = 3) {
        this.map.setView(latlong, zoom, {
            "animate": true,
            "pan": {
                "duration": duration,
                easeLinearity: 1
            }
        });
    }

    drawPath(paths) {
        let self = this;
        paths.forEach(function (item) {
            var color = "rgb("+item["color"][0]+" ,"+item["color"][1]+","+ item["color"][2]+")";

            const colorLine = L.polyline(item.points, {color: color, weight: 2}).addTo(self.map);

            self.paths.push(colorLine);
        });

        this.tracksRendered = true;
        this.fitBoundsIfReady();
    }

    fitBoundsIfReady() {
        // Only fit bounds once both task and tracks are rendered
        if (!this.taskRendered || !this.tracksRendered) {
            return;
        }

        const allLayers = [];

        // Add task layers from renderer
        if (this.renderer && this.renderer.taskLayers) {
            allLayers.push(...this.renderer.taskLayers);
        }

        // Add track paths
        if (this.paths) {
            allLayers.push(...this.paths);
        }

        // Create a feature group and fit bounds
        if (allLayers.length > 0) {
            const group = L.featureGroup(allLayers);
            this.map.fitBounds(group.getBounds(), {
                padding: [0, 0]
            });
        }
    }

}
